// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".collapse[data-v-b2cc8bf8] {\n  position: relative;\n  overflow: hidden;\n  transition: height 0.28s ease-in-out;\n}\n.collapse-control[data-v-b2cc8bf8] {\n  position: absolute;\n  bottom: 7px;\n  right: 8px;\n  font-size: 14px;\n  font-weight: 400;\n  color: #0a74e0;\n  cursor: pointer;\n}\n.collapse-control-icon[data-v-b2cc8bf8] {\n  margin-right: 2px;\n}\n", ""]);
// Exports
module.exports = exports;
